import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import { ActionInterface } from "../../Interface/ActionInterface";

export default function* paymentConsiderIncomeForAgency(action: ActionInterface): any {
  try {
    const res = yield call(Http.patch, `payment/${action.payload?.payment.id}/agency-income`);

    yield put({
      type: Constants.GLOBAL_CHARGES_LIST_OUTDATE_REQUESTS
    })

    yield put({
      type: Constants.GLOBAL_PAYMENTS_LIST_OUTDATE_REQUESTS
    })

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this, res);
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.GLOBAL_PAYMENT_CONSIDER_INCOME_FOR_AGENCY_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchPaymentConsiderIncomeForAgency() {
  yield takeEvery(Constants.GLOBAL_PAYMENT_CONSIDER_INCOME_FOR_AGENCY_START, paymentConsiderIncomeForAgency);
}
